import React from 'react';
import GlassyModal from 'components/ui/GlassyModal';
import Icon from 'components/AppIcon';

const ServiceSelectionModal = ({ isOpen, onClose, onSelectService }) => {
  const services = [
    {
      id: 'assignment',
      title: 'Submit Assignment',
      description: 'Get expert help with your assignments, essays, research papers, and more.',
      icon: 'FileText',
      color: 'from-primary to-secondary'
    },
    {
      id: 'class-management',
      title: 'Class Management',
      description: 'Let us handle your entire course, including attendance, discussions, and assignments.',
      icon: 'BookOpen',
      color: 'from-accent to-accent-600'
    }
  ];

  return (
    <GlassyModal
      isOpen={isOpen}
      onClose={onClose}
      title="Choose a Service"
      icon="Zap"
      maxWidth="max-w-2xl"
    >
      <div className="space-y-6">
        <p className="text-white/80 mb-6">
          Select the service you need assistance with. Our team of experts is ready to help you succeed.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service) => (
            <button
              key={service.id}
              onClick={() => onSelectService(service.id)}
              className="group bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl p-6 text-left transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              <div className={`w-16 h-16 mb-4 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={service.icon} size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{service.title}</h3>
              <p className="text-white/70">{service.description}</p>
              <div className="mt-4 flex justify-end">
                <div className="bg-white/10 rounded-full p-2 group-hover:bg-white/20 transition-colors duration-300">
                  <Icon name="ArrowRight" size={20} className="text-white" />
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 text-center">
          <p className="text-white/60 text-sm">
            Not sure which service is right for you? <button onClick={() => onSelectService('consultation')} className="text-accent hover:text-accent-400 underline">Request a free consultation</button>
          </p>
        </div>
      </div>
    </GlassyModal>
  );
};

export default ServiceSelectionModal;